"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentType = void 0;
var PaymentType;
(function (PaymentType) {
    PaymentType["ONLINE"] = "ONLINE";
    PaymentType["OFFLINE"] = "OFFLINE";
    PaymentType["BOTH"] = "BOTH";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
//# sourceMappingURL=offering-payment-type.js.map